import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { internalLayerVersionsKeys } from './queryKeys';
import type {
  InternalLayerVersion,
  ListInternalLayerVersionsQuery,
  ListLayersResponse,
  ListInternalLayerVersionsFilter,
} from './types';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';

export const fetchInternalLayerVersions = async (
  query: ListInternalLayerVersionsQuery
): Promise<ListLayersResponse<InternalLayerVersion>> => {
  const resp = await axios.get<ListLayersResponse<InternalLayerVersion>>(
    config.apiGateway.internal_layer_versions,
    {
      params: buildSearchQueryParams<ListInternalLayerVersionsFilter>(query),
    }
  );

  return resp.data;
};

export const useListInternalLayerVersionsQuery = (
  query: ListInternalLayerVersionsQuery,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: internalLayerVersionsKeys.list(query),
    queryFn: async () => {
      return fetchInternalLayerVersions(query);
    },
    enabled: options?.enabled ?? true,
  });
};
